<template>
  <div v-if="item">
    <h2>#{{ item.id }}</h2>
    <fields-list :item="item" :fields="fields" />
     <div class="save-panel">
      <button class="btn btn-sm btn-success btn-icon mt-4" @click="updateItem">
        <span class="ti-save"></span>Сохранить
      </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent } from "../../../plugins/functions";

import FieldsList from "../FieldsList";

export default {
  data: () => ({
    cardLink: "brands/card",
    cardSetLink: "brands/update",
    item: null,
    fields: [
      {
        col: "col-4",
        key: "image",
        label: "Логотип",
        type: "img", //textarea, field, checkbox
      },
      {
        col: "col-8",
        key: "title",
        label: "Название",
        type: "field",
        textType: "text",
      },
    ],
  }),
  components: {
    FieldsList,
  },
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    updateItem() {
      this.cardUpdate(this.cardSetLink, this.item);
    },
  },
};
</script>
<style>
</style>
